import { useEffect, useRef } from "react";
import { postLocation, stopLocation } from "@/lib/api";
import { getDeviceId } from "@/lib/access";

const INTERVAL_MS = 20000;

// While a map is open, share the rider's GPS with the shop every ~20s (health & safety; disclosed in the waiver).
export const useLocationShare = (route, stopIndex, navigating) => {
  const lastRef = useRef(null);
  const sentAtRef = useRef(0);
  const metaRef = useRef({ stopIndex, navigating });
  metaRef.current = { stopIndex, navigating };

  useEffect(() => {
    if (!route?.id || !route?.access || !navigator.geolocation) return undefined;
    const routeId = route.id;
    const device = getDeviceId();
    const send = (force) => {
      const p = lastRef.current;
      if (!p || (!force && Date.now() - sentAtRef.current < INTERVAL_MS - 500)) return;
      sentAtRef.current = Date.now();
      postLocation({ route_id: routeId, device_id: device, lat: p.lat, lng: p.lng, heading: p.heading, speed: p.speed, stop_index: metaRef.current.stopIndex, navigating: metaRef.current.navigating }).catch(() => {});
    };
    const watch = navigator.geolocation.watchPosition(
      (g) => { lastRef.current = { lat: g.coords.latitude, lng: g.coords.longitude, heading: g.coords.heading, speed: g.coords.speed }; if (!sentAtRef.current) send(true); },
      () => {},
      { enableHighAccuracy: true, maximumAge: 10000, timeout: 20000 },
    );
    const timer = setInterval(() => send(false), INTERVAL_MS);
    return () => {
      navigator.geolocation.clearWatch(watch);
      clearInterval(timer);
      lastRef.current = null; sentAtRef.current = 0;
      stopLocation(routeId, device).catch(() => {});
    };
  }, [route?.id, route?.access]);
};
